import request from '../api/index';
import { API_ROUTES } from '../consts';

export enum WorkflowType {
  /** When a customer that is trying to upgrade their plan by themselves through the app */
  InAppPlanPurchase = 'InAppPlanPurchase',
  /** When a sales person is trying to upgrade a customer's plan through the back office */
  BackOfficeSales = 'BackOfficeSales',
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type InAppPlanPurchaseWorkflowData = {};

export type BackOfficeSalesWorkflowData = {
  userEmailToInvite?: string;
  monthlyCreditsToSet?: number;
};

export type WorkflowData = InAppPlanPurchaseWorkflowData | BackOfficeSalesWorkflowData;

export enum BillingPeriod {
  Monthly = 'monthly',
  Yearly = 'yearly',
  Quarterly = 'quarterly',
  SemiYearly = 'semi-yearly',
}

export type CreatePaymentLinkParams = {
  accountId: string;
  userId?: string;
  planDefinitionId: string;
  billingPeriod?: BillingPeriod;
  quantity?: number;
  customUnitPrice?: number;
  allowAdjustableQuantity?: boolean;
  workflowType?: WorkflowType;
  workflowData?: WorkflowData;
}

export const createPaymentLink = async (
  params:CreatePaymentLinkParams,
): Promise<PaymentLink>  => {
  const { data } = await request.post(API_ROUTES.PAYMENT_LINK, params);

  return data;
};
